<template>
  <b-row class="justify-center">
    <b-col sm="12" md="5">
      <span class="mr-1 mb-2 text-capitalize">
        {{ $t("search") }}
        بر اساس
      </span>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="radio-group-2"
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="radio-sub-component"
        >
          <b-form-checkbox value="service_name">عنوان خدمات</b-form-checkbox>
          <b-form-checkbox value="status">وضعیت پرداخت </b-form-checkbox>
<!--          <b-form-checkbox value="host_mobile">موبایل </b-form-checkbox>-->
          <b-form-checkbox value="host_name">نام میزبان</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-col>
    <b-col>
      <b-row>
        <b-col sm="12" md="7">
          <b-input-group>
            <b-form-select
                v-if="selected.indexOf('status') > -1"
                value="host_mobile"
                :options="StatusOptions"
                v-model="searchInput"
                class="mt-1"
            />

            <b-form-input

              v-else
              :disabled="selected.length == 0"
              v-model="searchInput"
              placeholder=""
            />
            <b-input-group-append v-if="isSearchResult">
              <b-button @click="searchBase('delete')" variant="danger"
                >X</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col>
          <b-button variant="primary" block  @click="searchBase()">
            <span v-if="submitLoading">
              <b-spinner small class="p-0 m-0" />
              <span class="sr-only">Loading...</span>
            </span>

            <div v-else class="text-capitalize"  @keyup.enter="searchBase()">جستجو</div>
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckboxGroup,
  BFormCheckbox,
  BButton,
  BRow,
  BCol,
  BSpinner,
  BInputGroup,
  BInputGroupAppend, BFormSelect,
} from "bootstrap-vue";

export default {
  props: ["value","city", "selectedFilter", "submitLoading", "isSearchResult"],
  components: {
    BFormSelect,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BButton,
    BRow,
    BSpinner,
    BCol,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      searchInput: "",
      selected: this.$props.selectedFilter,
      StatusOptions: [
        { value: 'pending', text: 'درحالت انتظار' },
        { value: 'success', text: 'پرداخت موفق' },
        { value: 'fail', text: 'پرداخت ناموفق' },
      ],
    };
  },
  computed: {},
  methods: {
    clear() {
      this.searchInput = "";
    },
    searchBase(type) {
      if (type == "delete") {
        this.clear();
      }
      this.$emit("searchBase", {
        searchInput: type == "delete" ? "" : this.searchInput,
        selectedFilter: this.selected,
        type: type,
      });
    },
  },
  watch: {
    searchInput(value) {
      this.$emit("input", this.searchInput);
    },
  },
};
</script>
